// extracted by mini-css-extract-plugin
export var container = "YouTubeVideo-module--container--a6c1d";
export var video = "YouTubeVideo-module--video--bf224";